import React from "react";
import styled from "styled-components";

const TabNav = ({ tabs, activeKey, onChange }) => (
  <TabNavBar>
    {tabs.map(({ key, label, icon: Icon }) => (
      <TabNavItem
        key={key}
        aria-selected={activeKey === key}
        onClick={() => onChange(key)}
      >
        {Icon && <Icon size={16} strokeWidth={2} />}
        {label}
      </TabNavItem>
    ))}
  </TabNavBar>
);

export default TabNav;

const TabNavBar = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid #e9eaeb;
`;

const TabNavItem = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: none;
  background: transparent;
  padding: 12px 2px;
  margin-bottom: -1px;
  font-size: 14px;
  font-weight: 500;
  color: #667085;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;

  svg {
    color: #98a2b3;
    transition: color 0.15s ease;
  }

  &:hover {
    color: #344054;
  }

  &:hover svg {
    color: #667085;
  }

  &[aria-selected="true"] {
    color: #6941c6;
    font-weight: 600;
    border-bottom-color: #6941c6;
  }

  &[aria-selected="true"] svg {
    color: #6941c6;
  }
`;
